/**
 * Parse and validate a project export file.
 * Returns { project, pages } on success, or throws with a user-friendly message.
 */
export function parseProjectExport(text) {
  if (!text || typeof text !== "string") {
    throw new Error("Empty or invalid file.");
  }

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("The file is not valid JSON.");
  }

  if (!data || typeof data !== "object") {
    throw new Error("The file does not contain a valid export object.");
  }

  if (!data.project || typeof data.project !== "object") {
    throw new Error("Missing 'project' field in export file.");
  }

  if (!data.pages || !Array.isArray(data.pages)) {
    throw new Error("Missing 'pages' array in export file.");
  }

  const project = {
    name: data.project.name || "Imported Project",
    id: data.project.id || "",
  };

  const pages = data.pages
    .map((entry) => {
      const screen = entry.screen || entry;
      if (!screen || screen.error) return null;
      return {
        name: screen.name || "Untitled",
        slug: screen.slug || "",
        html: screen.html || "",
        css: screen.css || "",
        js: screen.js || "",
        scripts: screen.scripts || {},
        projectData: screen.projectData || null,
        meta: screen.meta || {},
      };
    })
    .filter(Boolean);

  return { project, pages };
}
